import { Container, Box, Typography, Grid, InputLabel, TextField, Switch, Backdrop, CircularProgress, Select, MenuItem, FormHelperText, FormControl } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useForm, Controller } from 'react-hook-form'
import { useRrhh } from '../../../../shared/context/rrhhContext'
import { useNavigate, useParams } from 'react-router'
import { IconButton, Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import SaveIcon from '@mui/icons-material/Save'
import { useUtiles } from '../../../../shared/context/utilesContext'
import SelectLocationComponent from '../../components/SelectLocationComponent'
import ClearIcon from '@mui/icons-material/Clear'
import { useEffect } from 'react'
import { useAuth } from '../../../../shared/context/authContext'
import { useAbility } from '../../../../shared/context/AbilityContext'
export default function CreateUpdateRrhhView() {
    const { hashCode } = useParams()
    const theme = useTheme()
    const navigate = useNavigate()
    const { toogleOpenSilder, locationString } = useUtiles()
    const { roles, getAllRoles, loadingGetRoles } = useAuth()
    const { control, handleSubmit, formState: { errors }, setValue } = useForm({
        defaultValues: {
            num_document: '',
            fullName: '',
            email: '',
            position: '',
            phone: '',
            is_active: true,
            location: null,
            role: null
        }
    })

    const { createRrhh, loadingCreateRrhh, setPersonal, personal, selectLocation, getRrhhByHashCode, updateRrhh, loadingUpdateRrhh } = useRrhh()
    const handleFieldChange = (name, value) => {
        setPersonal({ ...personal, [name]: value })
        setValue(name, value)
    }

    const handleCreateRrhh = async () => {
        if (personal.id) {
            await updateRrhh()
        } else {
            await createRrhh()
        }
    }

    const handleClearClassification = (name) => {
        setPersonal({ ...personal, [name]: null })
        setValue(name, null)
    }

    useEffect(() => {
        getAllRoles()
    }, [])



    useEffect(() => {
        if (hashCode) {
            getRrhhByHashCode(hashCode)
        }
    }, [hashCode])

    useEffect(() => {
        if (personal.id) {
            setValue('num_document', personal.num_document)
            setValue('fullName', personal.fullName)
            setValue('email', personal.email)
            setValue('position', personal.position)
            setValue('phone', personal.phone)
            setValue('is_active', personal.is_active)
            setValue('location', personal.location)
            setValue('role', personal.role?.id )
        }
    }, [personal])


    const ability = useAbility();
    useEffect(() => {
        if(!ability.can('read', 'USERS')){
            navigate('/')
        }
    }, [ability])

    return (
        <Container maxWidth="xl" sx={{
            padding: '0px', margin: '0px',
        }}>
            <form onSubmit={handleSubmit(handleCreateRrhh)}>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px'
                }}>
                    <IconButton
                        onClick={() => navigate('/rrhh')}
                        sx={{
                            borderRadius: '12px',
                            padding: '8px',
                            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                            transition: 'all 0.2s',
                            "&:hover": {
                                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>

                    <Button
                        variant="contained"
                        startIcon={<SaveIcon />}
                        type='submit'
                        sx={{
                            borderRadius: '8px',
                            padding: '8px 25px',
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            borderRadius: '50px',
                            transition: 'all 0.2s',

                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        Guardar
                    </Button>
                </Box>


                <Box sx={{
                    borderRadius: '10px',
                    backgroundColor: theme.palette.background.paper,
                    padding: '20px',
                    position: 'relative'
                }}>
                    <Typography variant="h6">{personal.id ? 'Editar Recurso Humano' : 'Crear Recurso Humano'}</Typography>
                    <Grid container spacing={2} columns={12} sx={{ mt: 2 }}>

                        <Grid item size={{ xs: 12 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Ubicación </InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese la ubicación del recurso humano
                            </Typography>
                            <Controller
                                control={control}
                                name="location"
                                render={({ field }) => (
                                    <Box sx={{ position: 'relative', width: '100%' }}>
                                        <TextField
                                            onClick={() => toogleOpenSilder(<SelectLocationComponent setSelectLocationParent={selectLocation} />, 500, 'Buscar ubicación')}
                                            fullWidth
                                            variant="outlined"
                                            sx={{ mt: 1 }}
                                            value={locationString(personal[field.name])}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                        placeholder="Buscar ubicación"
                                        slotProps={{
                                            input: {
                                                readOnly: true
                                            }
                                        }}

                                        />
                                        {personal[field.name] && (
                                            <IconButton
                                                size="small"
                                                onClick={() => handleClearClassification(field.name)}
                                                sx={{
                                                    position: 'absolute',
                                                    right: '8px',
                                                    top: '50%',
                                                    transform: 'translateY(-50%)',
                                                }}
                                            >
                                                <ClearIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                    </Box>
                                )}
                            />
                        </Grid>

                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >
                                Documento <span style={{ color: 'red' }}>*</span>
                            </InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese el número de documento del recurso humano
                            </Typography>
                            <Controller
                                control={control}
                                name="num_document"
                                rules={{
                                    required: 'El documento es requerido',
                                    pattern: {
                                        value: /^[0-9]+$/,
                                        message: 'El documento debe ser un número'
                                    }
                                }}
                                render={({ field }) => (
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        sx={{ mt: 1 }}
                                        value={field.value}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                        error={!!errors.num_document}
                                        helperText={errors.num_document?.message}
                                        placeholder="Ingresa el número de documento"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Nombre <span style={{ color: 'red' }}>*</span></InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese el nombre del recurso humano
                            </Typography>
                            <Controller
                                control={control}
                                name="fullName"
                                rules={{
                                    required: 'El nombre es requerido',
                                    minLength: {
                                        value: 3,
                                        message: 'El nombre debe tener al menos 3 caracteres'
                                    }
                                }}
                                render={({ field }) => (
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        sx={{ mt: 1 }}
                                        value={field.value}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                        error={!!errors.fullName}
                                        helperText={errors.fullName?.message}
                                        placeholder="Ingresa el nombre completo"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Email <span style={{ color: 'red' }}>*</span></InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese el email del recurso humano
                            </Typography>
                            <Controller
                                control={control}
                                name="email"
                                rules={{
                                    required: 'El email es requerido',
                                    pattern: {
                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                        message: 'El email no es válido'
                                    }
                                }}
                                render={({ field }) => (
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        sx={{ mt: 1 }}
                                        value={field.value}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value.trim())}
                                        error={!!errors.email}
                                        helperText={errors.email?.message}
                                        placeholder="Ingresa el email"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Cargo </InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese el cargo del recurso humano
                            </Typography>
                            <Controller
                                control={control}
                                name="position"
                                render={({ field }) => (
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        sx={{ mt: 1 }}
                                        value={field.value}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                        placeholder="Ingresa el cargo"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Teléfono</InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese el teléfono del recurso humano
                            </Typography>
                            <Controller
                                control={control}
                                name="phone"
                                render={({ field }) => (
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        sx={{ mt: 1 }}
                                        value={field.value}
                                        onChange={(e) => handleFieldChange(field.name, e.target.value)}
                                        placeholder="Ingresa el teléfono"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Habilitado</InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Ingrese el estado del recurso humano
                            </Typography>
                            <Controller
                                control={control}
                                name="is_active"
                                render={({ field }) => (
                                    <Switch
                                        fullWidth
                                        sx={{ mt: 1 }}
                                        checked={field.value}
                                        onChange={(e) => handleFieldChange(field.name, e.target.checked)}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item size={{ xs: 12 }}>
                            <InputLabel sx={{ fontWeight: 'bold', color: theme.palette.text.primary }} >Rol de usuario <span style={{ color: 'red' }}>*</span></InputLabel>
                            <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: 'block' }} >
                                Seleccione el rol de usuario del recurso humano
                            </Typography>
                            <FormControl fullWidth variant="outlined" sx={{ mt: 1 }}>
                            <Controller
                                control={control}
                                name="role"
                                rules={{
                                    required: 'El rol es requerido'
                                }}
                                render={({ field }) => (
                                    <Select
                                        fullWidth
                                        variant="outlined"
                                        sx={{ mt: 1 }}
                                        value={field.value || ''}
                                        onChange={(e) => {
                                            const selectedRole = roles.find(r => r.id === e.target.value) || null;
                                            setPersonal(prev => ({ ...prev, role: selectedRole }));
                                            field.onChange(e.target.value);
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 300
                                                }
                                            }
                                        }}
                                    >
                                        <MenuItem value="">
                                            <em>Seleccione un rol</em>
                                        </MenuItem>
                                        {roles?.map((role) => (
                                            <MenuItem key={role.id} value={role.id}>
                                                {role.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                                
                            />
                            <FormHelperText error={!!errors.role}>{errors.role?.message}</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
            </form>

            <Backdrop open={loadingCreateRrhh}>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <Typography variant="h6" sx={{ color: theme.palette.text.primary }}>
                        Creando ubicación...
                    </Typography>
                    <CircularProgress />
                </Box>
            </Backdrop>
        </Container>
    )
}   